"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ficarra": {
    "4985c699": [{
      "hkey": "03ca940c",
      "slug": "crocevia-sauro",
      "name": "Crocevia-Sauro",
      "primary": true,
      "skipSearch": false
    }],
    "crocevia": [{
      "hkey": "03ca940c",
      "slug": "crocevia-sauro",
      "name": "Crocevia-Sauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cb59011e": [{
      "hkey": "8bbe10e8",
      "slug": "matini-casette",
      "name": "Matini-Casette",
      "primary": true,
      "skipSearch": false
    }],
    "matini": [{
      "hkey": "8bbe10e8",
      "slug": "matini-casette",
      "name": "Matini-Casette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6cf58b6e": [{
      "hkey": "03ca940c",
      "slug": "crocevia-sauro",
      "name": "Crocevia-Sauro",
      "primary": true,
      "skipSearch": false
    }],
    "sauro": [{
      "hkey": "03ca940c",
      "slug": "crocevia-sauro",
      "name": "Crocevia-Sauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ficarra"
    }]
  }
};
exports["default"] = _default;